import React from "react";
import Login from "../AdminLogin/AdminLogin";
import AdminSection from "../../compnents/AdminSection/AdminSection";

function Admin() {
  return <AdminSection />;
}

export default Admin;
